import forEach from 'lodash/forEach';

export const scrollObservable = tableClassName => {
	let isFixHeader = false;

	document.addEventListener('scroll', () => {
		const $table = document.querySelectorAll(`.${tableClassName}`)[0];
		const $headerToFix = $table && $table.querySelectorAll('#fixed-head')[0];
		const rect = $table && $table.getBoundingClientRect();
		if (rect && rect.top < 0 && !isFixHeader) {
			//calculate current th width and add to action
			const itemsGetWidth = $table.querySelectorAll('[data-get-width]');
			const itemsAddWidth = $table.querySelectorAll('[data-add-width]');
			forEach(itemsGetWidth, ($item, i) => {
				const rect = $item.getBoundingClientRect();
				itemsAddWidth[i].setAttribute('style', `width:${rect.width}px`);
			});
			addClass($headerToFix, 'position-fixed');
			isFixHeader = true;
		} else if (rect && rect.top > 0 && isFixHeader) {
			removeClass($headerToFix, 'position-fixed');
			isFixHeader = false;
		}
	});
};

const addClass = (el, className) => {
	if (el.classList) {
		el.classList.add(className);
	} else {
		el.className += ' ' + className;
	}
};

const removeClass = (el, className) => {
	if (el.classList) {
		el.classList.remove(className);
	} else {
		el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	}
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/table/general/fixed-head.js